import SolutionsList from './SolutionsList';

export default SolutionsList;
